import { Button, Card, Col, Container, Row } from '@themesberg/react-bootstrap'
import React, { useEffect, useState } from 'react'
import SafeFormatMessage from '../Shared/SafeFormatMessage/SafeFormatMessage'
import useSharedFunctions, {
  getKeyByValueWithFormattedMessage,
} from '../Shared/SharedFunctions/SharedFunctions'
import useRequest from '../../../axios/apis/useRequest'
import { cycle } from '../../../const'
import { paymentPlatforms } from '../../../const/const'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPaypal, faStripe } from '@fortawesome/free-brands-svg-icons'
import { useDispatch, useSelector } from 'react-redux'
import { get } from 'lodash'
import { Wrapper } from './PaymentMethodSelection.styled'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { setAllProductPublic } from '../../../store/slices/publicProductsSlice'
import { useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'

const PaymentMethodSelection = ({ priceData }) => {
  const { getLocalizedString } = useSharedFunctions()
  const dispatch = useDispatch()
  const intl = useIntl()
  const [orderID, setOrderID] = useState('')
  const [orderData, setOrderData] = useState()
  const [selectedMethod, setSelectedMethod] = useState('stripe')
  const { productSystemName, priceName, productOwnerSystemName } = useParams()

  const listProduct = useSelector((state) => state.publicProducts.products)
  const productData = Object.values(
    Object.fromEntries(
      Object.entries(listProduct).filter(
        ([key, value]) => value.systemName === productSystemName
      )
    )
  )[0]
  const planList = productData?.plans

  const productId = productData?.id

  const direction = useSelector((state) => state.main.direction)
  const { currencyCode } = useSelector((state) => state.main.currency)
  const defaultCurrencyCode = useSelector(
    (state) => state.main.defaultCurrency.currencyCode
  )

  const hash = window.location.hash
  const array = hash.split('#')
  const orderIDHash = array.find((element) => element.includes('order-'))

  const {
    getOrderByIdPublic,
    identifyOrderPaymentPlatform,
    getProductListPublic,
  } = useRequest()
  useEffect(() => {
    if (Object.values(listProduct).length > 0) {
      return
    }

    ; (async () => {
      const productList = await getProductListPublic()
      dispatch(setAllProductPublic(productList.data.data))
    })()
  }, [Object.values(listProduct).length > 0])

  useEffect(() => {
    if (!orderIDHash) {
      return
    }
    setOrderID(orderIDHash.replace('order-', ''))
  }, [orderIDHash])
  useEffect(() => {
    if (!orderID || orderData) {
      return
    }

    ; (async () => {
      const order = await getOrderByIdPublic(orderID)
      setOrderData(order.data.data)
    })()
  }, [orderID])

  // Update hash when a payment method is selected
  const handlePaymentSelection = (method) => {
    setSelectedMethod(method)
  }

  // Ensure a method is selected before proceeding
  const handleSubmit = async () => {
    try {
      await identifyOrderPaymentPlatform(orderID, {
        paymentPlatform: paymentPlatforms[selectedMethod],
      })

      console.log("isPlanSelectionRedirectionEnabled" ,listProduct?.[productId]?.isPlanSelectionRedirectionEnabled)
      console.log("planSelectionRedirectUrl" , listProduct?.[productId]?.planSelectionRedirectUrl)


      if (listProduct?.[productId]?.isPlanSelectionRedirectionEnabled &&
          listProduct?.[productId]?.planSelectionRedirectUrl
      ) {
        window.top.location.href = `${listProduct?.[productId]?.planSelectionRedirectUrl
          }?plan-price=${priceName
          }&currency-code=${!currencyCode || currencyCode == 'null' ? defaultCurrencyCode : currencyCode}&trial-enabled=${orderData?.orderItems[0]?.trialPeriodInDays > 0
          }&language=${intl.locale 
          }&order-id=${orderID}`

      }
      else {
        const updatedHash = `#order-${orderID}#${selectedMethod}`
        window.location.hash = updatedHash
      }
    } catch (error) {
      console.error('Error identifying order payment platform:', error)
    }
  }

  return (
    <Wrapper>
      <div className="main-container">
        <Container>
          <Card style={{ backgroundColor: 'var(--themeBackground)' }}>
            <Card.Body>
              <Row>
                <Col
                  md={5}
                  className=" d-flex align-items-center justify-content-center border-right-1 border-light "
                >
                  <div>
                    {orderData?.orderItems[0]?.trialPeriodInDays ? (
                      <>
                        <Card.Title className="mb-0">
                          <span
                            className="fw-bold"
                            style={{ color: 'var(--primary4)' }}
                          >
                            {orderData?.orderItems[0]?.description}
                          </span>
                          <div
                            style={{
                              color: 'var(--primary3)',
                              fontSize: 'var( --normalFont)',
                              fontWeight: 'normal',
                            }}
                          >
                            <SafeFormatMessage id="Try" />{' '}
                            {priceData?.plan.displayNameLocalizations
                              ? getLocalizedString(
                                priceData?.plan.displayNameLocalizations
                              )
                              : priceData?.plan.displayName}
                          </div>
                          <div
                            className="fw-bold"
                            style={{
                              color: 'var(--second-color)',
                              fontSize: 'var( --hugeFont)',
                            }}
                          >
                            {orderData?.orderItems[0]?.trialPeriodInDays}{' '}
                            <SafeFormatMessage id="Days" />{' '}
                            <SafeFormatMessage id="Free" />{' '}
                          </div>
                        </Card.Title>
                        <SafeFormatMessage id="Then" />{' '}
                        {orderData?.calculatedOrderTotal.formattedPrice}{' '}
                        {cycle[priceData?.cycle] && (
                          <SafeFormatMessage id={cycle[priceData?.cycle]} />
                        )}{' '}
                      </>
                    ) : (
                      <>
                        {' '}
                        <span
                          className="fw-bold mb-3"
                          style={{ color: 'var(--primary4)' }}
                        >
                          {orderData?.orderItems[0]?.description}
                        </span>
                        <div
                          style={{
                            color: 'var(--primary3)',
                            fontSize: 'var( --normalFont)',
                            fontWeight: 'normal',
                          }}
                          className="mt-2 mb-0"
                        >
                          <SafeFormatMessage id="Start-With" />{' '}
                        </div>
                        <div
                          className="fw-bold p-0 m-0 mt-0"
                          style={{
                            color: 'var(--second-color)',
                            fontSize: 'var( --hugeFont)',
                          }}
                        >
                          {orderData?.calculatedOrderTotal.formattedPrice}{' '}
                          <span
                            style={{
                              color: 'var(--second-color)',
                              fontSize: 'var( --normalFont)',
                            }}
                          >
                            {cycle[priceData?.cycle] && (
                              <SafeFormatMessage id={cycle[priceData?.cycle]} />
                            )}
                          </span>
                        </div>
                        <div
                          style={{
                            color: 'var(--primary4)',
                          }}
                          className="p-0 m-0"
                        >
                          {orderData?.orderItems[0]?.displayName}
                        </div>
                      </>
                    )}
                  </div>
                </Col>
                <Col
                  md={7}
                  className={` my-2 ${direction == 'ltr ' ? 'pl-5' : 'pr-5 '}`}
                >
                  <Card.Title className="mb-0">
                    <SafeFormatMessage id="Payment-Method" />
                  </Card.Title>
                  <span style={{ color: 'var(--primary3)' }}>
                    <SafeFormatMessage
                      id="How-Would-You-Like-To-Pay?"
                      defaultMessage={'How would you like to pay?'}
                    />
                  </span>
                  <div className="my-3">
                    {Object.entries(paymentPlatforms)
                      .slice(1, -1)
                      .map(([method, value]) => (
                        <div
                          key={value}
                          className="d-flex justify-content-center"
                        >
                          <Button
                            key={value}
                            variant={
                              selectedMethod === method ? 'primary' : 'light'
                            }
                            className="m-2 w-75"
                            onClick={() => handlePaymentSelection(method)}
                            style={{ width: '100%' }}
                          >
                            <div className="d-flex justify-content-between align-items-center">
                              <span>
                                {method ==
                                  getKeyByValueWithFormattedMessage(
                                    paymentPlatforms,
                                    paymentPlatforms.paypal,
                                    true
                                  ) && (
                                    <FontAwesomeIcon
                                      className={
                                        direction == 'rtl' ? 'ml-2' : 'mr-2'
                                      }
                                      icon={faPaypal}
                                    />
                                  )}
                                {method ==
                                  getKeyByValueWithFormattedMessage(
                                    paymentPlatforms,
                                    paymentPlatforms.stripe,
                                    true
                                  ) && (
                                    <FontAwesomeIcon
                                      className={
                                        direction == 'rtl' ? 'ml-2' : 'mr-2'
                                      }
                                      icon={faStripe}
                                    />
                                  )}
                                <SafeFormatMessage
                                  id={method}
                                  defaultMessage={
                                    method == 'paypal'
                                      ? 'Paypal'
                                      : method == 'stripe'
                                        ? 'Stripe'
                                        : method
                                  }
                                />
                              </span>
                              {selectedMethod === method && (
                                <FontAwesomeIcon
                                  icon={faCheckCircle}
                                  color="var(--second-color)"
                                  className={
                                    direction == 'rtl' ? 'mr-2' : 'ml-2'
                                  }
                                />
                              )}
                            </div>
                          </Button>
                        </div>
                      ))}
                  </div>
                  <Card.Footer className="px-0 mb-0 pb-0 d-flex justify-content-end">
                    <Button variant="secondary" onClick={handleSubmit}>
                      <SafeFormatMessage id="Next" />
                    </Button>
                  </Card.Footer>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </Wrapper>
  )
}

export default PaymentMethodSelection
